// extracted by mini-css-extract-plugin
export default {"title":"styles_title__Ca9Ym","separator":"styles_separator__RfHZy","search-list-results":"styles_search-list-results__7wjEK","list":"styles_list__UKu2D"};